import _defineProperty from "/opt/build/repo/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* global document */
import * as React from 'react';
import { createPortal } from 'react-dom';
import { useImperativeHandle, useEffect, useMemo, useRef, useContext, forwardRef, memo } from 'react';
import { applyReactStyle } from '../utils/apply-react-style';
import { MapContext } from './map';
import { arePointsEqual } from '../utils/deep-equal';
/* eslint-disable complexity,max-statements */
function Marker(props, ref) {
  var _useContext = useContext(MapContext),
    map = _useContext.map,
    mapLib = _useContext.mapLib;
  var thisRef = useRef({
    props: props
  });
  thisRef.current.props = props;
  var marker = useMemo(function () {
    var hasChildren = false;
    React.Children.forEach(props.children, function (el) {
      if (el) {
        hasChildren = true;
      }
    });
    var options = _objectSpread(_objectSpread({}, props), {}, {
      element: hasChildren ? document.createElement('div') : null
    });
    var mk = new mapLib.Marker(options);
    mk.setLngLat([props.longitude, props.latitude]);
    mk.getElement().addEventListener('click', function (e) {
      var _a, _b;
      (_b = (_a = thisRef.current.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, {
        type: 'click',
        target: mk,
        originalEvent: e
      });
    });
    mk.on('dragstart', function (e) {
      var _a, _b;
      var evt = e;
      evt.lngLat = marker.getLngLat();
      (_b = (_a = thisRef.current.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
    });
    mk.on('drag', function (e) {
      var _a, _b;
      var evt = e;
      evt.lngLat = marker.getLngLat();
      (_b = (_a = thisRef.current.props).onDrag) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
    });
    mk.on('dragend', function (e) {
      var _a, _b;
      var evt = e;
      evt.lngLat = marker.getLngLat();
      (_b = (_a = thisRef.current.props).onDragEnd) === null || _b === void 0 ? void 0 : _b.call(_a, evt);
    });
    return mk;
  }, []);
  useEffect(function () {
    marker.addTo(map.getMap());
    return function () {
      marker.remove();
    };
  }, []);
  var longitude = props.longitude,
    latitude = props.latitude,
    offset = props.offset,
    style = props.style,
    _props$draggable = props.draggable,
    draggable = _props$draggable === void 0 ? false : _props$draggable,
    _props$popup = props.popup,
    popup = _props$popup === void 0 ? null : _props$popup,
    _props$rotation = props.rotation,
    rotation = _props$rotation === void 0 ? 0 : _props$rotation,
    _props$rotationAlignm = props.rotationAlignment,
    rotationAlignment = _props$rotationAlignm === void 0 ? 'auto' : _props$rotationAlignm,
    _props$pitchAlignment = props.pitchAlignment,
    pitchAlignment = _props$pitchAlignment === void 0 ? 'auto' : _props$pitchAlignment;
  useEffect(function () {
    applyReactStyle(marker.getElement(), style);
  }, [style]);
  useImperativeHandle(ref, function () {
    return marker;
  }, []);
  if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) {
    marker.setLngLat([longitude, latitude]);
  }
  if (offset && !arePointsEqual(marker.getOffset(), offset)) {
    marker.setOffset(offset);
  }
  if (marker.isDraggable() !== draggable) {
    marker.setDraggable(draggable);
  }
  if (marker.getRotation() !== rotation) {
    marker.setRotation(rotation);
  }
  if (marker.getRotationAlignment() !== rotationAlignment) {
    marker.setRotationAlignment(rotationAlignment);
  }
  if (marker.getPitchAlignment() !== pitchAlignment) {
    marker.setPitchAlignment(pitchAlignment);
  }
  if (marker.getPopup() !== popup) {
    marker.setPopup(popup);
  }
  return createPortal(props.children, marker.getElement());
}
export default memo(forwardRef(Marker));